// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GU-0","placeholdersHeader":"styles_placeholdersHeader__3eIzv","editorStyle":"styles_editorStyle__113eJ","placeholdersBox":"styles_placeholdersBox__-hUlK"};